import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from '../app/endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const bookingApi: any = createApi({
  reducerPath: 'bookingApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['booking'],
  endpoints: builder => ({
    findByBookingId: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.bookingDetailController.findByBookingId}/${body.id}`,
          method: 'GET',
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
        };
      },
    }),
    getAllBookingDetailBySearchCriteria: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.bookingDetailController.getAllBookingDetailBySearchCriteria}`,
          method: 'POST',
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        };
      },
    }),
    saveBookingDetail: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.bookingDetailController.saveBookingDetail}`,
          method: 'POST',
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        };
      },
    }),
    updateBookingDetail: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.bookingDetailController.updateBookingDetail}`,
          method: 'PUT',
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        };
      },
    }),
    cancelBooking: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.bookingDetailController.cancelBooking}/${body.bookingId}/${body.cancellationReason}`,
          method: 'PUT',
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        };
      },
    }),
    updateActualTime: builder.mutation({
      query: body => {
        return {
          url: spotFinder.bookingDetailController.updateActualTime,
          method: 'POST',
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        }
      }
    }),

    findByBookingCodeAndEmail: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.bookingDetailController.findByBookingCodeAndEmail}/${body.bookingCode}/${body.customerEmail}`,
          method: 'GET',
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {}
        }
      }
    }),
    getByBookingId: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.SubBookingDetailController.getByBookingId}`,
          method: 'POST',
          body: body.payload,
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {}
        };
      },
    }),
    completeBookingDetail: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.bookingDetailController.completeBookingDetail}`,
          method: 'PUT',
          body: body.payload,
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {}
        };
      },
    }),
  }),
});

export const {
  useFindByBookingIdMutation,
  useGetAllBookingDetailBySearchCriteriaMutation,
  useSaveBookingDetailMutation,
  useUpdateBookingDetailMutation,
  useCancelBookingMutation,
  useUpdateActualTimeMutation,
  useFindByBookingCodeAndEmailMutation,
  useGetByBookingIdMutation,
  useCompleteBookingDetailMutation,

} = bookingApi;
